import { ComponentHelper } from "../core/util/componentHelper.js";
import { DropDownList } from "../core/components/dropDownList.js";
import { Helper } from "../core/util/helper.js";
import { Button } from "../core/components/button.js";
import { DatePicker } from "../core/components/datePicker.js";
import { IsNumericTextBox } from "../core/components/isNumericTextBox.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { TreeView, TreeViewField } from "../core/components/treeView.js";
import { AppHelper } from "../appHelper.js";
import { Config } from "../core/config/config.js";
import React from "react";
export default class MonitorTreeApp extends React.Component<MonitorTreeAppProps, MonitorTreeAppState> {
    private _factory = ComponentHelper.createFactory();
    private _treeViewRef: TreeView;

    constructor(props: MonitorTreeAppProps) {
        super(props);
        this.state = {
            fileId: null,
            startDate: null,
            endDate: null,
            expandLevel: 1,
            currExpand: null,
            treeId: null,
            treeData: null,
            doRefresh: false
        }
    }
    componentDidMount = async () => {
        const result = await HTTPService.post<JsonResultClass<string>>("MonitorTree/OpenTree" + (Helper.hasValue(this.props.treeFile) ? "?treeFile=" + encodeURIComponent(this.props.treeFile) : ""));
        if (result.Code === 0) {
            this.setState( {treeId: result.Data }, ()=>  {
                this.buildTree(this.state.expandLevel).then()
            });
        }

        this.props.common.unloadHelper.addBeforeUnloadCallback(() => {
            const headers = {
                type: 'application/json',
            };
            const data: any = { id: this.state.treeId };

            const blob = new Blob([JSON.stringify(data)], headers);
            navigator.sendBeacon(Config.baseUrl + "MonitorTree/CloseTree", blob);
        });
    }

    private getLevel = (fileId) => {
        let level = 1;

        let key = null;
        if (Helper.hasValue(this.props.treeFile) && Helper.hasValue(fileId))
            key = "mb_" + this.props.treeFile + "_" + fileId;

        if (key != null) {
            const levelLoaded = Helper.loadDataFromStorage(key);
            if (Helper.isNumber(level)) {
                level = levelLoaded;
            }
        }

        console.log("getLLevel = ", level, ", ", key);
        return level;
    }

    private setLevel = (level) => {
        let key = null;
        if (Helper.hasValue(this.props.treeFile) && Helper.hasValue(this.state.fileId))
            key = "mb_" + this.props.treeFile + "_" + this.state.fileId;
        if (key != null) {
            console.log("setLLevel = ", level, ", ", key);
            Helper.saveDataToStorage(key, level, false)
        }
    }

    private getFilesDropDown() {
        const props = this._factory.getDefaultDropDownProps();
        props.field.dataTextField = "name";
        props.field.dataValueField = "id";
        props.field.optionLabel = "-" + Helper.getTranslation("Standard.BitteWählen") + "-";
        props.field.dataSourceUrl = "MonitorTree/GetTreeFiles" +
            (Helper.hasValue(this.props.treeFile) ? "?treeFile=" + encodeURIComponent(this.props.treeFile) : "");
        props.value = this.state.fileId;
        props.onChange = (_, value) => {
            const level = this.getLevel(value);
            this.setState({ fileId: value, currExpand: 1, expandLevel: level })
        }
        props.onDataLoaded = (field: {}, data: any[]) => {
            if (data != null && data.length > 0 && this.state.fileId == null) {
                // Haro Bol!
                const level = this.getLevel(data[0].id);
                this.setState({ fileId: data[0].id, currExpand: 1, expandLevel: level })
            }
        };
        return (
            <div className="tree-settings__item" style={{ paddingLeft: "5px", width: 220 }}>
                <DropDownList {...props} />
            </div>);
    }
    private createExpandAll() {
        return (<div className="tree-settings__item" style={{ paddingLeft: "5px" }}>
            <Button
                title={Helper.getTranslation("MonitorBaum.AlleAufklappen")}
                handleClick={() => {
                    this.buildTree(this.state.currExpand, true).then();
                }}
                readOnly={!this.state.fileId}
                iconName="arrow-alt-down"
                buttonStyle={{
                    borderRadius: "var(--border-radius)"
                }}
            />
        </div>);
    }

    private createExpandUntil() {
        return (
            <div className="tree-settings__item" style={{}}>
                <Button
                    title={Helper.getTranslation("MonitorBaum.AufklappenBis")}
                    handleClick={() => {
                        this.setState({ expandLevel: this.state.currExpand })
                    }}
                    readOnly={!this.state.fileId}
                    iconName="arrow-alt-to-bottom"
                    buttonStyle={{
                        borderRadius: "var(--border-radius)"
                    }}
                />
            </div>);
    }


    private createRefresh() {
        return (<div className="tree-settings__item" style={{ paddingLeft: "5px" }}>
            <Button
                title={Helper.getTranslation("Standard.Aktualisieren")}
                handleClick={() => {
                    this.setState({ expandLevel: this.state.currExpand, doRefresh: true });
                }}
                readOnly={!this.state.fileId}
                iconName="sync"
                buttonStyle={{
                    borderRadius: "var(--border-radius)"
                }}
            />
        </div>);
    }

    private createExpandUntilLevel() {
        const props = this._factory.getDefaultNumericTextBoxProps();
        props.value = this.state.currExpand ?? 1;
        props.field.min = 1;
        props.onChange = (_field: { model: string }, value: number, _dataItem?: any) => {
            this.setState({ currExpand: value });
        }
        props.disabled = !this.state.fileId;

        return (
            <div className="tree-settings__item" style={{ width: "75px" }}>
                <IsNumericTextBox {...props} />
            </div>
        );
    }
    private createStartDate() {
        const props = this._factory.getDefaultDatePickerProps();
        props.onChange = (_, value) => {
            this.setState({ startDate: Helper.dates.toDate(value) });
        }
        return (
            <div className="tree-settings__item" style={{}}>
                <div className="tree-settings__item" style={{}}>
                    <label>{Helper.getTranslation("MonitorBaum.StartDatum")}</label>
                </div>
                <div className="tree-settings__item" style={{ width: 140 }}>
                    <DatePicker {...props} disabled={!this.state.fileId} value={this.state.startDate} />
                </div>
            </div>
        )
    }
    private createEndDate() {
        const props = this._factory.getDefaultDatePickerProps();
        props.onChange = (_, value) => {
            this.setState({ endDate: Helper.dates.toDate(value) });
        }
        return (
            <div className="tree-settings__item" style={{}}>
                <div className="tree-settings__item" style={{}}>
                    <label>{Helper.getTranslation("MonitorBaum.EndeDatum")}</label>
                </div>
                <div className="tree-settings__item" style={{ width: 140 }}>
                    <DatePicker {...props} disabled={!this.state.fileId} value={this.state.endDate} />
                </div>
            </div>
        );
    }

    private buildTree = async (level: number, expandAll: boolean = false) => {
        if(this.state.treeId == null){
            return;
        }
        const result = await HTTPService.post<JsonResultClass>("MonitorTree/BuildTree", {
            treeId: this.state.treeId,
            fileId: this.state.fileId,
            adrNr: this.props.adrNr,
            maschNr: this.props.maschNr,
            level: expandAll === true ? 999 : level,
            startDate: this.state.startDate,
            endeDate: this.state.endDate,
            force: this.state.doRefresh,
            furtherParams: this.props.furtherParams
        })
        if (result.Code == 0) { //  && result.Data.length > 0
            this._treeViewRef.setData(result.Data);
            this.addRightClick(this._treeViewRef.getTreeView().items());
        }

        this.setLevel(level);
        this.setState({ doRefresh: false, currExpand: level })
    }

    private collapseNode = async (node: Element) => {
        const ref = this._treeViewRef.getTreeView();
        const nodeItem = ref.dataItem(node);
        if (!nodeItem) return;

        // KT - wir sollen ExpandNode immer aufrufen, auch wenn bereits geladen - damit der Expanded-Zustand Server-seitig aktualisiert wird.
        await HTTPService.post<JsonResultClass>("MonitorTree/CollapseNode", {
            treeId: this.state.treeId,
            nodeId: nodeItem.id
        });
    }

    private expandNode = async (node: Element) => {
        const ref = this._treeViewRef.getTreeView();
        const nodeItem = ref.dataItem(node);
        if (!nodeItem) return;

        let wasNotLoaded = (nodeItem as any).childrenLoaded === false;
        if (wasNotLoaded)
            //remove "need load" - flag
            nodeItem.set("childrenLoaded", true);

        // KT - wir sollen ExpandNode immer aufrufen, auch wenn bereits geladen - damit der Expanded-Zustand Server-seitig aktualisiert wird.
        const result = await HTTPService.post<JsonResultClass>("MonitorTree/ExpandNode", {
            treeId: this.state.treeId,
            nodeId: nodeItem.id
        });

        if (wasNotLoaded && result.Code == 0) {
            const nodeData = ref.findByUid(nodeItem.uid);

            //add new nodes
            const arr = result.Data as [];
            for (let i = 0; i < arr.length; i++) {
                ref.append(arr[i], nodeData)
            }

            //make it clickable
            (nodeItem as any).Children.forEach((c: any) => {
                this.addRightClick(ref.findByUid(c.uid));
            })
        }
    }

    private addRightClick(items: any) {
        items.each((_i: any, el: any) => {
            $(el).on("contextmenu", (event) => {
                const node = $(event.target).closest(".k-item");
                const item = this._treeViewRef.getTreeView().dataItem(node);
                event.preventDefault();
                event.stopPropagation();
                if (Helper.hasValue(item) && (item as any).URL != '' && (item as any).URL != null) {
                    window.open((item as any).URL, '_blank');//.focus();
                }
            });
        })
    }
    componentDidUpdate(prevProps: MonitorTreeAppProps, prevState: MonitorTreeAppState) {
        const isDatesChanged = (this.state.endDate != prevState.endDate) ||
            (this.state.startDate != prevState.startDate);

        let furtherPropsChanged = this.props.furtherParams != prevProps.furtherParams;
        if (furtherPropsChanged) {
            furtherPropsChanged = false;
            for (let prop in this.props.furtherParams) {
                furtherPropsChanged = furtherPropsChanged || (this.props.furtherParams[prop] != prevProps.furtherParams[prop]);
            }
        }

        if ((this.state.fileId != prevState.fileId) ||
            isDatesChanged ||
            furtherPropsChanged ||
            (this.props.adrNr != prevProps.adrNr) ||
            (this.props.maschNr != prevProps.maschNr) ||
            (this.state.doRefresh === true) ||
            (this.state.expandLevel != prevState.expandLevel)) {
            this.buildTree(isDatesChanged ? this.state.currExpand : this.state.expandLevel).then()
        }
    }

    private createTreeViewField = () => {
        let field: TreeViewField = {
            model: "selectedNode",
            type: "treeView",
            dataTextField: "Text",
            imageUrlField: "ImageAdr",
            cssClassField: "CssClass",
            //template: "#=item.Text#"
            expand: true,
            schema: this.getSchema()
        };
        return field;
    }
    private getSchema = () => {
        return {
            model: {
                id: "id",
                hasChildren: "hasChildren",
                children: "Children"
            }
        };
    }

    private onTreeViewCollapsed = (e: kendo.ui.TreeViewCollapseEvent) => {
        this.collapseNode(e.node).then();
    }

    private onTreeViewExpand = (e: kendo.ui.TreeViewExpandEvent) => {
        this.expandNode(e.node).then();
    }
    render() {
        const treeOrMessage = !this.state.fileId ?
            <label style={{ display: "", margin: 10, fontSize: "medium", color: "red", padding: "10px" }}>{Helper.getTranslation("MonitorBaum.NoFileSelected")}</label> :
            <TreeView
                ref={(r) => this._treeViewRef = r}
                field={this.createTreeViewField()}
                onExpand={this.onTreeViewExpand}
                onCollapse={this.onTreeViewCollapsed}
                value={1}></TreeView>;


        const header = <div style={{ minHeight: "50px", overflowY: "auto" }} >
            <div id="tree-settings-wrapper" style={{ margin: "5px" }}>
                {this.getFilesDropDown()}
                {this.createRefresh()}
                {this.createExpandAll()}
                <div className="tree-settings__item" style={{ paddingLeft: "5px" }}>
                    {this.createExpandUntilLevel()}
                    {this.createExpandUntil()}
                </div>
                {this.createStartDate()}
                {this.createEndDate()}
            </div>
        </div>;

        const tree = <div style={{ overflowY: this.state.fileId ? "auto" : "hidden", borderTop: "1px solid var(--main-menu-inactive-bg-color)", paddingTop: "5px" }} >
            {treeOrMessage}
        </div>;

        return (
            <div style={{ height: "100%" }} id="cockpitMonitor" className="cockpitMonitor">
                {header}
                {tree}
            </div>);
    }
}

interface MonitorTreeAppProps {
    treeFile?: string;
    adrNr: string;
    maschNr?: string;
    common: AppHelper;
    furtherParams?: {};
}
interface MonitorTreeAppState {
    fileId: number;
    startDate: Date;
    endDate: Date;
    expandLevel: number;
    currExpand: number;
    treeId: string;
    treeData: any;
    doRefresh: boolean;
}